<template>
  <div>
    <nav
      class="navbar navbar-default fixed-top"
      :class="['nav-main', { 'nav-expanded': sidebarExpanded, 'nav-messages': isMessagesRoute, 'nav--flush': noSidebar }]"
      style="z-index: 999"
    >
      <div
        class="container padding-container-full"
        :style="$isMobile ? { justifyContent: 'right' } : {}"
      >
        <!-- Logo dentro del nav cuando no hay sidebar principal (gestor de anuncios) -->
        <a
          v-if="!$isMobile && noSidebar"
          href="#"
          class="nav-brand"
          @click.prevent="goRouteHome()"
        >
          <img
            src="/img/1x/logo.png"
            :alt="$t('navigation.alt.logo')"
            class="img-fluid"
          />
        </a>

        <!-- Ubicación actual (vistas full-screen del gestor) -->
        <div v-if="!$isMobile && noSidebar" class="nav-flush-loc">
          <span class="nav-flush-loc__sep"></span>
          <span class="nav-flush-loc__txt">{{ flushTitle }}</span>
        </div>

        <div
          v-if="!$isMobile && !noSidebar"
          class="link-sopport"
          style="font-weight: bold; color: #28a745; text-align: left"
        >
          {{ $t('navigation.support.question') }}
          <button
            @click.prevent="openWhatsApp"
            style="
              box-shadow: 0px 0px 15px 1px #eee;
              background: #ffffff;
              border: none;
              border-radius: 9px;
              padding-inline: 10px;
              color: #000000;
              font-weight: 600;
              padding-block: 2px;
            "
          >
            {{ $t('navigation.support.whatsappCta') }}
            <img
              src="/whatsapp.png"
              :alt="$t('navigation.alt.whatsapp')"
              class="img-fluid"
              style="width: 20px"
            />
          </button>
        </div>

        <!-- El logo, solo en pantalla estrecha. Se decide por ANCHO en el CSS y no
             con `v-if="$isMobile"`: eso mira el dispositivo y con la ventana
             estrecha en un portatil no se enteraba. -->
        <a href="#" class="nav-logo-movil" @click.prevent="goRouteHome()">
          <img src="/img/1x/favicon.png" :alt="$t('navigation.alt.logo')" />
        </a>

        <div
          class="d-flex flex-row box-logo-drop"
          style="align-items: center !important"
        >
          <button
            v-if="!noSidebar"
            class="nav-guides-btn"
            type="button"
            :aria-label="$t('miscTailHc.maquetaNav.guidesAria')"
            @click.prevent="openGuides"
          >
            <span class="nav-guides-btn__ico">
              <svg viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9.3" fill="currentColor" />
                <path d="M10.3 8.85v6.3a.7.7 0 0 0 1.08.59l4.95-3.15a.7.7 0 0 0 0-1.18L11.38 8.26a.7.7 0 0 0-1.08.59Z" fill="#fff" />
              </svg>
            </span>
            <span class="nav-guides-btn__dot"></span>
            <span class="nav-guides-btn__tip">{{ $t("miscTailHc.maquetaNav.guidesTip") }}</span>
          </button>

          <button
            v-if="!noSidebar"
            class="nav-novedades-btn"
            type="button"
            :aria-label="$t('miscTailHc.maquetaNav.novedadesAria')"
            @click.prevent="openNovedades"
          >
            <span class="nav-novedades-btn__ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9.5 17h5" />
                <path d="M10.2 20h3.6" />
                <path d="M12 4.2a5 5 0 0 0-3 9c.5.4.8.9.9 1.5l.1.5h4l.1-.5c.1-.6.4-1.1.9-1.5a5 5 0 0 0-3-9Z" />
                <path d="M12 1.4v1M4.6 4.6l.7.7M19.4 4.6l-.7.7M2.2 11.6h1M20.8 11.6h1" />
              </svg>
            </span>
            <span v-if="novedadesUnread > 0" class="nav-novedades-btn__badge">{{ novedadesUnread > 9 ? '9+' : novedadesUnread }}</span>
            <span class="nav-novedades-btn__tip">{{ $t("miscTailHc.maquetaNav.novedadesTip") }}</span>
          </button>

          <!-- Recorrido de novedades (TourNovedades, montado en App.vue). -->
          <button
            v-if="!noSidebar"
            class="nav-novedades-btn nav-tour-btn"
            type="button"
            :aria-label="$t('miscTailHc.maquetaNav.tourAria')"
            @click.prevent="$root.$emit('open-tour-novedades')"
          >
            <span class="nav-novedades-btn__ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
                <path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" />
              </svg>
            </span>
            <span class="nav-novedades-btn__tip">{{ $t("miscTailHc.maquetaNav.tourTip") }}</span>
          </button>

          <notifications-nav
            v-if="!isPropietario && !noSidebar"
            @eventOpenService="openService"
            @eventActiveModalData="activeModalData"
          />

          <!-- Volver al Dashboard (solo en vistas full-screen del gestor de anuncios) -->
          <button
            v-if="noSidebar"
            class="nav-close"
            type="button"
            :aria-label="$t('miscTailHc.maquetaNav.backToPanel')"
            :title="$t('miscTailHc.maquetaNav.backToPanel')"
            @click.prevent="goRouteHome()"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
            </svg>
          </button>

          <dropdown-accommodations v-if="!noSidebar" />
        </div>
      </div>
      <modalDatos />
    </nav>
  </div>
</template>

<script>
import modalDatos from "./modalDatos.vue";
import NotificationsNav from "@/components/Template/notificationsNav.vue";
import dropdownAccommodations from "@/components/Template/dropdownAccommodations.vue";

export default {
  name: "navClient",
  props: {
    sidebarExpanded: Boolean,
  },
  components: {
    modalDatos,
    NotificationsNav,
    dropdownAccommodations,
  },
  mounted() {
    this.$funtion.Notifications();
    // El drawer de novedades (montado en App.vue) emite el contador; aquí solo
    // lo mostramos en la estrellita.
    this.$root.$on("novedades-unread", this.setNovedadesUnread);

    if (
      this.$store.state.userRoot &&
      this.$store.state.userRoot?.servicios &&
      this.$store.state.userRoot?.suscription_id_stripe
    ) {
      this.$store.state.demo = false;
    }
  },
  beforeDestroy() {
    this.$root.$off("novedades-unread", this.setNovedadesUnread);
  },
  watch: {
    "$store.state.userRoot"() {
      if (
        this.$store.state.userRoot &&
        this.$store.state.userRoot?.servicios &&
        this.$store.state.userRoot?.suscription_id_stripe
      ) {
        this.$store.state.demo = false;
      }
    },
  },
  data() {
    return {
      mostrar: null,
      novedadesUnread: 0,
    };
  },
  computed: {
    isMessagesRoute() {
      return this.$route.name === "PageMensajes";
    },
    isPropietario() {
      return this.$store.state.subUser?.sub_role === "propietario";
    },
    // Vistas full-screen del gestor de anuncios: aquí se oculta el sidebar
    // principal, así que mostramos el logo dentro del nav y lo pegamos a la izquierda.
    noSidebar() {
      if (["ListingManager", "AgentIAManager", "DirectBookingsSettings"].includes(this.$route.name)) {
        return true;
      }
      // Sección "Mi cuenta" (ruta padre "Perfil").
      return this.$route.matched.some((r) => r.name === "Perfil");
    },
    // Título que indica dónde está el usuario en las vistas full-screen.
    flushTitle() {
      if (this.$route.matched.some((r) => r.name === "Perfil")) {
        return this.$t("miscTailHc.maquetaNav.accountTitle");
      }
      if (this.$route.name === "AgentIAManager") return this.$t("miscTailHc.maquetaNav.agentIaTitle");
      if (this.$route.name === "DirectBookingsSettings") return this.$t("miscTailHc.maquetaNav.directBookingsTitle");
      return this.$t("miscTailHc.maquetaNav.listingsTitle");
    },
  },
  methods: {
    // Abre el Centro de guías en video (componente global VideoGuides en App.vue).
    openGuides() {
      this.$root.$emit("open-video-guides");
    },
    openNovedades() {
      this.$root.$emit("open-novedades");
    },
    setNovedadesUnread(n) {
      this.novedadesUnread = Number(n) || 0;
    },
    goRouteHome() {
      if (this.$route.name != "Dashboard") {
        this.$router.push({ name: "Dashboard" });
      }
    },
    openWhatsApp() {
      window.open("https://wa.me/+34642982154", "_blank");
    },
    activeModalData(id) {
      this.$funtion.modalDatosGeneral(id);
    },
    openService(id) {
      localStorage.setItem("service_id", null);
      window.location.href = "/business/service?service_id=" + id;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Móvil (≤700px, sin sidebar): el navbar sube por encima del banner de suscripción
   (z-index 1000) para que el menú lateral —que vive dentro del navbar— lo tape al abrir.
   En escritorio se queda en 999 para que el SIDEBAR (z-index 1000) vaya por encima del nav. */
@media (max-width: 700px) {
  .nav-main {
    z-index: 1001 !important;
  }
}
/* Vistas full-screen (gestor de anuncios / cuenta): el nav solo lleva la X →
   más bajo en móvil para no dejar tanto hueco arriba. */
@media (max-width: 767px) {
  .nav-main.nav--flush {
    height: 56px;
    min-height: 56px;
  }
}
.nav-main.nav-messages {
  box-shadow: none !important;
  border-bottom: 1px solid #eee !important;
  background: rgba(255, 255, 255, 0.98);
}

.nav-expanded {
  padding-left: 240px !important;
  transition: width 0.3s ease-in-out;
}

/* ── Vistas full-screen sin sidebar principal (gestor de anuncios) ──
   El logo va dentro del nav, todo pegado a la izquierda y el avatar a la derecha. */
.nav-brand {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
}
.nav-brand img {
  height: 40px;
  width: auto;
  display: block;
}
/* Ubicación actual junto al logo (vistas full-screen) */
.nav-flush-loc {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}
.nav-flush-loc__sep {
  width: 1px;
  height: 24px;
  background: #e5e7eb;
  display: inline-block;
}
.nav-flush-loc__txt {
  font-size: 15px;
  font-weight: 700;
  color: #1d2433;
  letter-spacing: -0.2px;
  white-space: nowrap;
}
.nav--flush .padding-container-full {
  max-width: 100% !important;   /* anula el ancho centrado del .container → nav amplio */
  width: 100%;
  padding-left: 0 !important;   /* logo alineado con el contenido de abajo */
  padding-right: 20px !important;
  justify-content: flex-start;
  gap: 18px;
}
.nav--flush .box-logo-drop {
  margin-left: auto;
  gap: 10px;
}

/* Botón X para volver al panel (estética de marca, fondo suave) */
.nav-close {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border: none;
  border-radius: 12px;
  background: #f1f3f7;
  color: #5c6476;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.16s ease, color 0.16s ease, transform 0.12s ease;
}
.nav-close:hover {
  background: #673de6;
  color: #fff;
  transform: translateY(-1px);
}



@media (max-width: 768px) {
  .padding-container-full {
        padding-inline: 0 !important;
  }
}


@media (min-width: 768px) {
  .padding-container-full {
    /* Full-width (anula el max-width centrado de Bootstrap) + mismo padding que el contenedor. */
    max-width: 100% !important;
    padding-left: 8%;
    padding-right: 2%;
  }
}


@media (min-width: 1450px) {
  .padding-container-full {
    max-width: 100% !important;
    padding-left: 8% !important;
    padding-right: 2% !important;
  }
}

/* ...resto de estilos igual que ya tenías... */
</style>


<style lang="scss" scoped>
.nav-expanded {
  padding-left: 240px !important; // Solo mover el contenedor a la derecha cuando el sidebar esté expandido
  transition: width 0.3s ease-in-out;
}

@media (min-width: 768px) {
  .padding-container-full {
    max-width: 100% !important;
    padding-left: 8%;
    padding-right: 2%;
  }
}

@media (min-width: 1450px) {
  .padding-container-full {
    max-width: 100% !important;
    padding-left: 8% !important;
    padding-right: 2% !important;
  }
}

@media (max-width: 720px) {
  /*
   * Aqui habia `justify-content: space-between; width: 100%` mas un `img` de
   * 44px con `margin-left: -22px`. Todo eso era de cuando el LOGO vivia dentro
   * de esta caja: repartir a los lados tenia sentido con el logo a la izquierda
   * y el avatar a la derecha. Ahora el logo es hermano (`.nav-logo-movil`), asi
   * que ese `width: 100%` estiraba la caja a lo ancho de la barra y el
   * `space-between` separaba los iconos todo lo posible. La regla del `img`
   * tampoco apunta ya a nada.
   *
   * Los iconos se agrupan a la derecha; de eso se encarga la regla de 991px.
   */
  .box-logo-drop {
    justify-content: flex-end;
    width: auto;
  }
  .select-account {
    position: absolute;
    right: 0px;
    top: -27px;
  }

  .menuPopap {
    width: 301px !important;
  }

  .noV {
    display: none !important;
  }

  .bloquePropie {
    min-height: 354px !important;
  }
}

.dropdown-menu .dropdown-item:active {
  color: #fff !important;
}

.dropdown-item {
  color: #525252 !important;
  font-weight: 500 !important;
  margin-block: 0px !important;

  i {
    font-size: 20px;
  }
}

.menuPopap {
  width: 400px;
  border-radius: 20px !important;
  max-height: 670px !important;
  box-shadow: 0px 0px 27px 3px #0000001c !important;
  margin-top: 10px;
}

.imageFavicon {
  height: 42px;
  width: 42px;
  border-radius: 50px;
  background-position: center;
  background-size: cover;
  background-color: #fff;
  background-position-y: -2px;
}

.nameCount {
  text-transform: uppercase;
  font-weight: 700;
  color: #505050;
}

.inactive {
  display: none !important;
}

.icon-leng {
  &:hover {
    transition: 0.4s;
    color: rgb(121, 186, 22);
  }
}

.dropdown-item {
  cursor: pointer;
}

/* Botón "Guías y ayuda" del header (junto a la campana). Círculo como los demás,
   con un play-en-disco morado de marca (óptimamente centrado) y un punto verde
   que respira para señalar que el asistente está activo. Abre el drawer global. */
.nav-guides-btn {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-right: 12px;
  border: 1px solid #e9ebf1;
  background: #f4f4f8;
  color: #673de6;
  cursor: pointer;
  transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    transform 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    box-shadow 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-novedades-btn {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-right: 12px;
  border: 1px solid #e9ebf1;
  background: #f4f4f8;
  color: #673de6;
  cursor: pointer;
  transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    transform 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    box-shadow 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-novedades-btn:hover {
  background: #efeafe;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px -6px rgba(18, 15, 30, 0.22);
}
.nav-novedades-btn:active { transform: translateY(0) scale(0.94); }
.nav-novedades-btn__ico { display: flex; }
.nav-novedades-btn__ico svg {
  width: 21px;
  height: 21px;
  display: block;
  filter: drop-shadow(0 2px 4px rgba(103, 61, 230, 0.28));
  transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-novedades-btn:hover .nav-novedades-btn__ico svg { transform: scale(1.1) rotate(6deg); }
.nav-novedades-btn__badge {
  position: absolute;
  top: 1px;
  right: 1px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border-radius: 9px;
  background: #f43f5e;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  line-height: 17px;
  text-align: center;
  border: 2px solid #fff;
  box-shadow: 0 0 0 0 rgba(244, 63, 94, 0.5);
  animation: navNovLive 2.2s cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
@keyframes navNovLive {
  0% { box-shadow: 0 0 0 0 rgba(244, 63, 94, 0.5); }
  70% { box-shadow: 0 0 0 7px rgba(244, 63, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(244, 63, 94, 0); }
}
.nav-novedades-btn__tip {
  position: absolute;
  top: calc(100% + 9px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: #14121c;
  color: #fff;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 8px;
  pointer-events: none;
  opacity: 0;
  z-index: 30;
  transition: opacity 0.16s ease, transform 0.18s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-novedades-btn__tip::before {
  content: "";
  position: absolute;
  top: -3px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #14121c;
  border-radius: 2px;
}
.nav-novedades-btn:hover .nav-novedades-btn__tip { opacity: 1; transform: translateX(-50%) translateY(0); }
@media (prefers-reduced-motion: reduce) { .nav-novedades-btn__badge { animation: none; } }

.nav-guides-btn:hover {
  background: #efeafe;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px -6px rgba(18, 15, 30, 0.22);
}
.nav-guides-btn:active {
  transform: translateY(0) scale(0.94);
}
.nav-guides-btn__ico {
  display: flex;
}
.nav-guides-btn__ico svg {
  width: 22px;
  height: 22px;
  display: block;
  filter: drop-shadow(0 2px 4px rgba(18, 15, 30, 0.28));
  transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-guides-btn:hover .nav-guides-btn__ico svg {
  transform: scale(1.07);
}
/* Punto "IA activa" */
.nav-guides-btn__dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #fff;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
  animation: navGuidesLive 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
@keyframes navGuidesLive {
  0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.5); }
  70% { box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}
/* Tooltip */
.nav-guides-btn__tip {
  position: absolute;
  top: calc(100% + 9px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: #14121c;
  color: #fff;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: -0.1px;
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 8px;
  pointer-events: none;
  opacity: 0;
  z-index: 30;
  transition: opacity 0.16s ease, transform 0.18s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-guides-btn__tip::before {
  content: "";
  position: absolute;
  top: -3px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #14121c;
  border-radius: 2px;
}
.nav-guides-btn:hover .nav-guides-btn__tip {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
@media (prefers-reduced-motion: reduce) {
  .nav-guides-btn__dot { animation: none; }
}

@media (max-width: 768px) {
  .notification {
    margin-right: 19px !important;
    margin-top: 14px !important;
  }

  .notification-icon {
    color: red;
    position: absolute;
    font-size: 8px;
    margin-left: 14px;
    margin-top: 12px !important;
  }
}

.notifications-hover:hover {
  transition: 0.3s;
  background: #fafafa;
}

.cabezera-noti {
  border-bottom: 1px solid #eee;
  padding: 11px 20px;
  font-size: 18px;
}

.ContextualPopover-arrow {
  z-index: 1;
  width: 21px;
  height: 21px;
  margin: -8px;
}

.dropdown-menu .dropdown-item {
  i {
    width: 25px;
  }
}

.dropdown-menu .dropdown-item {
  font-size: 14px;
  padding: 0.5rem 1rem;
  font-weight: bold;
  margin-left: 9px;
  color: #5e72e4;
  width: fit-content;
  margin-left: 9px;
  border-radius: 34px;
  margin-bottom: 12px;

  &:hover {
    transition: 0.2s;
    width: fit-content;
    margin-left: 9px;
    border-radius: 34px;
  }

  &:active {
    text-decoration: none;
    color: #fff;
    background-color: #5e72e4;
    border-radius: 34px;
  }
}

.dropdown-menu.user {
  min-width: 17rem;
}

.dropdown-toggle::after {
  display: none;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.navbar {
  // background: white;
  background: #fff;
  height: 66px;
  box-shadow: 0px 3px 5px 2px rgb(0 0 0 / 3%);
  // border-bottom: 1px solid #eee;
}

/* ===== RTL (arabe): el contenido despeja el sidebar por la derecha ===== */
[dir="rtl"] {
  .nav-expanded { padding-left: 0 !important; padding-right: 240px !important; }
  .nav--flush .padding-container-full { padding-left: 20px !important; padding-right: 0 !important; }
  .nav--flush .box-logo-drop { margin-left: 0; margin-right: auto; }
  .nav-guides-btn,
  .nav-novedades-btn { margin-right: 0; margin-left: 12px; }
}

/*
 * La barra de «¿Necesitas asistencia?» fuera de la navegación estrecha.
 *
 * Tenía `v-if="!$isMobile"`, que mira el DISPOSITIVO y no el hueco: con la
 * ventana estrecha en un portátil seguía saliendo, se comía la primera fila
 * entera y empujaba los iconos a una segunda línea. Se corta por ancho, que es
 * lo que de verdad manda aquí. La ayuda por WhatsApp sigue estando en el centro
 * de guías, que sí cabe.
 */
@media (max-width: 991px) {
  .link-sopport { display: none !important; }
}

/* ── La barra en pantalla estrecha ─────────────────────────────────────────
 *
 * Logo a la izquierda, iconos apretados a la derecha, todo en UNA fila.
 *
 * El reparto salia de `:style="$isMobile ? { justifyContent: 'right' } : {}"`,
 * que mira el DISPOSITIVO: con la ventana estrecha en un portatil no se aplicaba
 * y los botones quedaban desparramados de lado a lado.
 *
 * Los `::v-deep` no son un capricho: la campana, el robot y el avatar viven en
 * componentes hijos con estilos `scoped`, asi que una regla normal de aqui NO
 * los alcanza. Lo comprobe midiendo: seguian en 44px mientras el resto ya iba a
 * 36. Novedades se cae en estrecho porque no caben cinco cosas sin apretarlas, y
 * ademas esta dentro del propio menu.
 */
.nav-logo-movil { display: none; }

@media (max-width: 991px) {
  .nav-main .padding-container-full {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center;
    justify-content: space-between !important;
    padding-inline: 12px !important;
    gap: 8px;
  }

  .nav-logo-movil {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    line-height: 0;
  }
  .nav-logo-movil img { width: 32px; height: 32px; border-radius: 9px; object-fit: contain; }

  .nav-main .box-logo-drop { gap: 6px; margin-left: auto; flex-wrap: nowrap; width: auto; justify-content: flex-end; }

  /* Los circulos, todos del mismo tamano y sin margenes sueltos. */
  .nav-main .nav-guides-btn,
  .nav-main ::v-deep(.notif-trigger),
  .nav-main ::v-deep(.contenedorNotificaciones) {
    width: 36px !important;
    height: 36px !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
    flex-shrink: 0;
  }
  .nav-main ::v-deep(.notification-btn svg),
  .nav-main ::v-deep(.bot-notification-btn svg) { width: 19px !important; height: 19px !important; }
  .nav-main .nav-guides-btn__ico svg { width: 19px; height: 19px; }

  .nav-main .nav-novedades-btn { display: none !important; }

  /* El avatar, a la misma altura que los circulos. Medido antes: circulos de
     44px empezando en y=11 y avatar de 36px en y=15, dentro de un disparador de
     48. Tres alturas distintas en una fila de cinco cosas. */
  .nav-main ::v-deep(.notifications-shell) { width: auto !important; }
  /* En estrecho reparte el `gap: 6px` de la caja; el margen del avatar sobra. */
  .nav-main ::v-deep(.the-navbar__user-meta) { margin-left: 0 !important; }
  .nav-main ::v-deep(.dd-trigger) { height: 36px !important; padding: 0 !important; gap: 6px; }
  .nav-main ::v-deep(.dd-avatar) { width: 36px !important; height: 36px !important; border-radius: 10px; }
}
</style>
